import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import KeycloakService from './services/KeycloakService';
import HttpService from './services/HttpService';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import MainTheme from "./MainTheme";
import store from './services/StoreService';
import { Provider } from "react-redux";
import AppUnprotected from './AppUnprotected';

const container = document.getElementById('root');
const root = createRoot(container);
const renderApp = () => root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider theme={MainTheme}>
      <Provider store={store}>
        <App />
        </Provider>
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>,
)
// KeycloakService.initKeycloak(renderApp);
// HttpService.configure();
// reportWebVitals();


// if (!window.location.pathname.includes("/about-us")) {
  HttpService.configure();
  KeycloakService.initKeycloak(renderApp);
  reportWebVitals();
// } else {
  // HttpService.configure();
  //  root.render(
  //   <React.StrictMode>
  //     <BrowserRouter>
  //       <AppUnprotected />
  //     </BrowserRouter>
  //   </React.StrictMode>
  // );
// }
